module.exports = {
    ES_AR: 'es-AR',
    EN_US: 'en-US',
  };
  